var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { height: "100%" } },
    [
      _vm.showIndex === 0
        ? _c("link-error", { attrs: { "resource-id": _vm.resourceId } })
        : _vm._e(),
      _vm.showIndex === 1
        ? _c("link-pwd", {
            attrs: { "resource-id": _vm.resourceId, user: _vm.userId },
            on: { "fresh-token": _vm.refreshToken },
          })
        : _vm._e(),
      _vm.showIndex === 2
        ? _c("link-view", {
            attrs: { "resource-id": _vm.resourceId, user: _vm.userId },
          })
        : _vm._e(),
      _vm.showIndex === 3
        ? _c("link-expire", {
            attrs: { "resource-id": _vm.resourceId, user: _vm.userId },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }